import React from 'react';

const statusClass = {
  query: 's-inquiry',
  reserved: 's-new',
  cancelled: 's-cancelled',
  completed: 's-modified'
};

export function StatusBadge({ status }) {
  const key = String(status || 'query').toLowerCase();
  const label = key ? key.charAt(0).toUpperCase() + key.slice(1) : 'Query';
  return <span className={`status-badge ${statusClass[key] || 's-inquiry'}`}>{label}</span>;
}
